import React, { Component } from 'react';
import { LookupAlumnoCarrera } from '../AlumnoCarrera/LookupAlumnoCarrera';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';

function DownloadIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 4v10M7 11l5 5 5-5" />
      <path d="M4 20h16" />
    </svg>
  );
}

export class GenerateEstadoCurricular extends Component {
  static displayName = GenerateEstadoCurricular.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errorMessage: '',
      successMessage: '',
      showLookup: false,
      alumno: { codigo: '', descripcion: '' },
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('WWCertificados');
  }

  clearFeedback() {
    if (this.state.errorMessage || this.state.successMessage) {
      this.setState({ errorMessage: '', successMessage: '' });
    }
  }

  handleShowLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookup: true });
    }
  };

  handleHideLookup = () => {
    this.setState({ showLookup: false });
  };

  handleSelectAlumno = (value) => {
    const parts = value.split('%');
    this.clearFeedback();
    this.setState({
      showLookup: false,
      alumno: {
        codigo: parts[0],
        descripcion: parts[1] + ' — ' + parts[2],
      },
    });
  };

  isFormValid() {
    return this.state.alumno.codigo.length > 0 && this.state.alumno.descripcion.length > 1;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;
    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Debe seleccionar un alumno.' });
      return;
    }
    this.generatePdf();
  }

  async generatePdf() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '', successMessage: '' });

    const { data } = await constantClass.apiFetch('api/ecur/' + this.state.alumno.codigo, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || !data.returnModel) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo generar el estado curricular. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    try {
      const byteCharacters = atob(data.returnModel);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'estadoCurricular.pdf';
      link.click();
    } catch {
      this.setState({
        loading: false,
        errorMessage: 'No se pudo descargar el archivo PDF generado.',
      });
      return;
    }

    this.setState({
      loading: false,
      successMessage: 'El estado curricular se generó y descargó correctamente.',
    });
  }

  render() {
    const { loading, errorMessage, successMessage, alumno, showLookup } = this.state;
    const isBusy = loading;

    return (
      <div className="md-page md-form-page">
        <h1 className="md-form-page__title">Estado Curricular</h1>
        <p className="md-form-page__subtitle">
          Seleccione un alumno para generar y descargar el certificado en PDF.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {successMessage ? <span className="md-form-page__success">{successMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Generando estado curricular, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Alumno</span>
              <button
                type="button"
                className="md-form-page__pick-btn"
                onClick={this.handleShowLookup}
                disabled={isBusy}
              >
                Seleccione el Alumno
              </button>
              {showLookup ? (
                <LookupAlumnoCarrera
                  selectItem={this.handleSelectAlumno}
                  hideLookup={this.handleHideLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={alumno.descripcion}
                placeholder="Ningún alumno seleccionado"
                readOnly
                disabled
                aria-label="Alumno seleccionado"
              />
            </div>

            <div className="md-form-page__actions">
              <button
                type="submit"
                className="md-form-page__btn md-form-page__btn--primary"
                disabled={isBusy}
              >
                <DownloadIcon />
                Generar certificado
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
